import React, { useState, useEffect } from "react";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { toast } from "react-toastify";
import moment from "jalali-moment";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import OrderCardLeftPartTemplate from "../../../shares/OrderCardLeftPartTemplate";
import CustomerOrderCard from "../../shares/CustomerOrderCard";
import useFetch from "../../../../context/useFetch";
import SizeTextGrid from "../../../shares/SizeTextGrid";
import { fixNumbers } from "../../../../utils";
import { useSetting } from "../../../../context/SettingContext";
// import { defaultRingSize } from "../../../../constants/constants";

const OrderDetails = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const { defaultRingSize } = useSetting();
  const [currentOerdersDetail, setCurrentOerdersDetail] = useState({
    results: [],
    detail: {},
  });
  const [initialValues, setInitialValues] = useState({});
  const [nums, setNums] = useState(new Array(defaultRingSize + 1).fill(""));
  const update_nums = (ringId, ind, nValue) => {
    // let beforeNums = [...nums];
    // beforeNums[ind] = nValue;
    // setNums(beforeNums);
    let beforeNums = { ...initialValues };
    beforeNums[ringId][ind] = fixNumbers(nValue);
    setInitialValues(beforeNums);
  };

  const getCreateOrderDetailsApi = useFetch({
    method: "get",
    url: `Order_Service/${props.selectedRow?.id}/user_get_order_item_detail_from_order`,
    params:{
      see_pre_order: props.employeePreOrders ? true : undefined
    },
    trigger: false,
    setter: setCurrentOerdersDetail,
    argFunc: (res) => {
      let tmp = {};
      res.results.map((item, ind) => {
        tmp[item.id] = [];
        tmp[item.id].push(item.size_one_num);
        tmp[item.id].push(item.size_two_num);
        tmp[item.id].push(item.size_three_num);
        tmp[item.id].push(item.size_four_num);
        tmp[item.id].push(item.size_five_num);
        tmp[item.id].push(item.size_six_num);
      });

      setInitialValues(tmp);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const [selectedItem, setSelectedItem] = useState();
  const [patchData, setPatchData] = useState();
  const [childrenItemDate, setChildrenItemDate] = useState();

  const deleteDetailsApi = useFetch({
    method: "delete",
    url: `OrderItem_Service/${selectedItem}`,
    trigger: false,

    argFunc: (res) => {
      // toast.success("حذف مورد  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      getCreateOrderDetailsApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const updateDetailsApi = useFetch({
    method: "patch",
    url: `OrderItem_Service/${selectedItem}/update_order_item`,
    trigger: false,
    data: patchData,

    argFunc: (res) => {
      // toast.success("ویرایش سفارش  با موفقیت انجام شد.", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenModal(false);
      getCreateOrderDetailsApi.reFetch();
      props.getCreateOrderApi.reFetch();
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const update_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    setPatchData({
      size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,

      admin_size_one_num:
        initialValues[ringItemId][0] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][0]))
          : 0,
      admin_size_two_num:
        initialValues[ringItemId][1] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][1]))
          : 0,
      admin_size_three_num:
        initialValues[ringItemId][2] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][2]))
          : 0,
      admin_size_four_num:
        initialValues[ringItemId][3] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][3]))
          : 0,
      admin_size_five_num:
        initialValues[ringItemId][4] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][4]))
          : 0,
      admin_size_six_num:
        initialValues[ringItemId][5] !== ""
          ? parseInt(fixNumbers(initialValues[ringItemId][5]))
          : 0,

      receive_at: moment(childrenItemDate).format("YYYY-MM-DD"),
    });
    updateDetailsApi.reFetch();
  };

  const delete_ring_item = (ringItemId) => {
    setSelectedItem(ringItemId);
    deleteDetailsApi.reFetch();
  };

  const move_date_to_parent = (date) => {
    setChildrenItemDate(date);
  };

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          getCreateOrderDetailsApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-11/12"
        icon={<RemoveRedEyeIcon />}
        isOverflow={true}
        isNotBackdropClick={true}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="flex items-center justify-center">
            <span className="show-label">
              کد سفارش:{" "}
              <span className="show-value">
                {currentOerdersDetail.detail?.unique_id}
              </span>
            </span>
          </div>
          <div className="border-b border-dashed my-2"></div>
          <SizeTextGrid have5Col />
          <div className="md:max-h-96 md:overflow-scroll md:px-2 md:mb-2">
            {currentOerdersDetail.results.map((item, index) => {
              return [
                <CustomerOrderCard
                  update_ring_item={update_ring_item}
                  delete_ring_item={delete_ring_item}
                  showAcceptBtn
                  item={item}
                  move_date_to_parent={move_date_to_parent}
                  apiCall={updateDetailsApi}
                  canRemove={true}
                >
                  <OrderCardLeftPartTemplate
                    adminDidntNeedCustomerRequestNum
                    nums={nums}
                    update_nums={update_nums}
                    dynamicMap={true}
                    data_item={item}
                    ringId={item.id}
                    adminCantEdit={props.employeePreOrders ? false : true}
                    customerCanEdit
                    adminNeedColor
                  />
                </CustomerOrderCard>,
              ];
            })}
          </div>
        </div>
      </TableIconModal>
    </>
  );
};

export default OrderDetails;
